<template>
    <div>
        <FreeTrialBox v-if="$isLangDk && !isLoggedIn && isDesktopView" />

        <SingleCourseTableOfContents
            v-if="!isMicroLearningCourse"
            :videoTimeLinks="videoLinks"
            :course="course"
            :canCourseTestBeOpen="canUserSeeTest"
            :courseWithoutTestCompleted="courseWithoutTestCompleted"
        />

        <MicroLearningTableOfContents
            v-if="isMicroLearningCourse && microLearningSections"
            :microLearningElements="microLearningSections"
            :course="course"
            :canCourseTestBeOpen="canUserSeeTest"
            :courseWithoutTestCompleted="courseWithoutTestCompleted"
            :currentMicroLearningSection="currentMicroLearningSection"
            v-on:reInitializeVideo="reInitializeVideo"
        />

        <CourseTest
            :title="course.title"
            :courseId="course.id"
            :canCourseTestBeOpen="canUserSeeTest"
            :hasTest="course.isTestAvailable"
            :courseWithoutTestCompleted="courseWithoutTestCompleted"
            :isMicroLearningCourse="isMicroLearningCourse"
            :isDemo="course.demo"
            :isDigitalClassRoomTraining="isDigitalClassRoom"
            :isLiveWebinar="isLiveWebinar"
            :isTestOnly="isTestOnlyCourseType"
            :singleLearningPath="singleLearningPath"
            :noTableOfContents="!hasTableOfContents"
        />

        <CollectionPreview
            v-if="isCollectionCoursePage"
            :collectionAllCourses="collectionAllCourses"
            :currentCourseId="course.id"
            :learningPathName="learningPathName"
        />

        <CollectionsCourseBelongs
            :collections="course.coursesCollections"
            :learningPaths="course.learningPathsCollection"
        />
    </div>
</template>

<script>
    import FreeTrialBox from 'components/coursepage/freetrial/FreeTrialBox'
    import SingleCourseTableOfContents from 'components/coursepage/tableofcontents/SingleCourseTableOfContents'
    import MicroLearningTableOfContents from 'components/coursepage/microlearning/tableofcontents/MicroLearningTableOfContents'
    import CourseTest from 'components/coursepage/courseaddons/CourseTest'
    import CollectionsCourseBelongs from 'components/coursepage/courseaddons/CollectionsCourseBelongs'
    import CourseOverview from 'components/coursepage/courseoverview/CourseOverview'
    import CollectionPreview from 'components/coursepage/collectionpreview/CollectionPreview'
    import { mapGetters } from 'vuex'
    export default {
        components: {
            FreeTrialBox,
            SingleCourseTableOfContents,
            MicroLearningTableOfContents,
            CourseTest,
            CollectionsCourseBelongs,
            CourseOverview,
            CollectionPreview
        },
        props: {
            course: Object,
            allDataLoaded: Boolean,
            videoLinks: {
                type: Array,
                default: () => []
            },
            courseWithoutTestCompleted: Boolean,
            isTestOnlyCourseType: Boolean,
            isLiveWebinar: Boolean,
            isCollectionCoursePage: Boolean,
            collectionAllCourses: Array,
            learningPathName: String,
            isDigitalClassRoom: Boolean
        },
        methods: {
            reInitializeVideo () {
                this.$emit('reInitializeVideo')
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                isMicroLearningCourse: 'MicroLearning/isMicroLearningCourse',
                canUserSeeTest: 'VideoPlayer/canUserSeeTest',
                microLearningSections: 'MicroLearning/getMicroLearningSections',
                currentMicroLearningSection: 'MicroLearning/getMicroLearningSection',
                singleLearningPath: 'LearningPaths/getSingleLearningPath'
            }),
            hasTableOfContents () {
                return this.isMicroLearningCourse ? !!this.microLearningSections : this.videoLinks.length > 0;
            }
        }
    }
</script>